import type { ReactNode } from 'react'

/**
 * A key, drawn as a key.
 *
 * A `<kbd>` rather than a styled span, because that is what it is, and it
 * means a screen reader says "keyboard, escape" rather than reading a symbol
 * out of context.
 *
 * Sized from `--text-keycap`, which is `--text-small` unless something sets
 * it. That indirection is worth one line: a legend enlarged for the television
 * needs its keys to grow with the words beside them, and the first attempt at
 * that made every keycap `em`-relative instead — which shrank the number
 * badges on the game picker from 24px to 14px at the very scale the change was
 * meant to help, because nothing on that path sets a font size for them to be
 * relative to.
 */
export function KeyCap({ children }: { children: ReactNode }) {
  return (
    <kbd className="border-border bg-surface-sunken text-ink inline-flex min-w-8 items-center justify-center rounded-[0.35em] border-2 border-b-4 px-2 py-0.5 font-sans text-(length:--text-keycap) leading-tight">
      {children}
    </kbd>
  )
}
